export default __webpack_public_path__ + "static/media/Rubik-Black.0c48d6ef.ttf";